var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      !_vm.edit
        ? _c(
            "CabeceraModalCrear",
            {
              attrs: { titulo: "Editar Alerta" },
              on: { cerrar: _vm.handleCerrar }
            },
            [
              _c("NavegacionModalCrud", {
                attrs: { pasos: _vm.pasos, "estado-id": _vm.estadoId },
                on: { guardar: _vm.handleGuardar },
                model: {
                  value: _vm.pasoActivoIndex,
                  callback: function($$v) {
                    _vm.pasoActivoIndex = $$v
                  },
                  expression: "pasoActivoIndex"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.edit
        ? _c("CabeceraModal", {
            attrs: { titulo: "Ver Detalle Alerta" },
            on: { cerrar: _vm.handleCerrar }
          })
        : _vm._e(),
      _vm.edit
        ? _c("CrudStepsNavBar", {
            attrs: { pasos: _vm.pasos },
            model: {
              value: _vm.pasoActivoIndex,
              callback: function($$v) {
                _vm.pasoActivoIndex = $$v
              },
              expression: "pasoActivoIndex"
            }
          })
        : _vm._e(),
      _c(
        "v-stepper",
        {
          model: {
            value: _vm.pasoActivoIndex,
            callback: function($$v) {
              _vm.pasoActivoIndex = $$v
            },
            expression: "pasoActivoIndex"
          }
        },
        [
          !_vm.edit
            ? _c("CrudStepperHeader", {
                attrs: {
                  pasos: _vm.pasos,
                  "paso-activo-index": _vm.pasoActivoIndex
                }
              })
            : _vm._e(),
          _c(
            "CrudStepperItems",
            [
              _c(
                "CrudStepperContent",
                { attrs: { paso: _vm.pasos.configurarAlerta } },
                [
                  _c(
                    "div",
                    { attrs: { align: "center" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { md10: "" } },
                        [
                          _c(
                            "v-form",
                            {
                              model: {
                                value: _vm.valid,
                                callback: function($$v) {
                                  _vm.valid = $$v
                                },
                                expression: "valid"
                              }
                            },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "rounded-card",
                                  staticStyle: { padding: "3%" }
                                },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    attrs: {
                                      label: "Nombre Alerta",
                                      "error-messages": _vm.errors.collect(
                                        "nombre_conf"
                                      ),
                                      "data-vv-name": "nombre_conf",
                                      required: "",
                                      disabled: _vm.edit
                                    },
                                    model: {
                                      value: _vm.alerta.nombre_conf,
                                      callback: function($$v) {
                                        _vm.$set(_vm.alerta, "nombre_conf", $$v)
                                      },
                                      expression: "alerta.nombre_conf"
                                    }
                                  }),
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      },
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true }
                                      }
                                    ],
                                    ref: "tiempo_conf",
                                    attrs: {
                                      label: "Tiempo Análisis (Minutos)",
                                      "error-messages": _vm.errors.collect(
                                        "tiempo_conf"
                                      ),
                                      "data-vv-name": "tiempo_conf",
                                      required: "",
                                      disabled: _vm.edit,
                                      rules: [_vm.validateNumber],
                                      title:
                                        "Corresponde a la cantidad de tiempo en minutos que se considerarán, para establecer una posible fuga."
                                    },
                                    model: {
                                      value: _vm.alerta.tiempo_conf,
                                      callback: function($$v) {
                                        _vm.$set(_vm.alerta, "tiempo_conf", $$v)
                                      },
                                      expression: "alerta.tiempo_conf"
                                    }
                                  }),
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      },
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true }
                                      }
                                    ],
                                    ref: "variacion",
                                    attrs: {
                                      label:
                                        "Variación Combustible (% Combustible)",
                                      "error-messages": _vm.errors.collect(
                                        "variacion"
                                      ),
                                      "data-vv-name": "variacion",
                                      required: "",
                                      disabled: _vm.edit,
                                      rules: [_vm.validateNumberPercentage],
                                      title:
                                        "Es la tolerancia en la disminución del porcentaje de combustible, para generar una alerta."
                                    },
                                    model: {
                                      value: _vm.alerta.variacion,
                                      callback: function($$v) {
                                        _vm.$set(_vm.alerta, "variacion", $$v)
                                      },
                                      expression: "alerta.variacion"
                                    }
                                  }),
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      },
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true }
                                      }
                                    ],
                                    ref: "velocidad",
                                    attrs: {
                                      label: "Velocidad Detención (Km/Hr)",
                                      "error-messages": _vm.errors.collect(
                                        "velocidad"
                                      ),
                                      "data-vv-name": "velocidad",
                                      required: "",
                                      disabled: _vm.edit,
                                      rules: [_vm.validateNumber],
                                      title:
                                        "Es la velocidad que se considerará valida como una detención del vehículo."
                                    },
                                    model: {
                                      value: _vm.alerta.velocidad,
                                      callback: function($$v) {
                                        _vm.$set(_vm.alerta, "velocidad", $$v)
                                      },
                                      expression: "alerta.velocidad"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "CrudStepperContent",
                { attrs: { paso: _vm.pasos.asociarVehiculos } },
                [
                  _vm.showAsociarVehiculos
                    ? _c(
                        "v-flex",
                        [
                          _c("AsociarFlotaEtiquetaVehiculo", {
                            attrs: {
                              "col-def-vehiculo": _vm.vehiculoColDefs,
                              "vehiculos-id-seleccionar":
                                _vm.alerta.jconf.vehiculos,
                              readonly: _vm.edit,
                              isTelemetria: true
                            },
                            on: { change: _vm.handleAsociacionesChange }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.showAsociarVehiculos
                    ? _c(
                        "v-flex",
                        [
                          _c("AsociarFlotaEtiquetaVehiculoXMantenimiento", {
                            on: { change: _vm.handleAsociacionesChangeM }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "CrudStepperContent",
                { attrs: { paso: _vm.pasos.configurarNotificaciones } },
                [
                  _c("ConfigurarNotificacionForm", {
                    attrs: {
                      modoVer: _vm.edit,
                      alertaSeleccionada: _vm.alerta.jconf,
                      isFuga: true
                    },
                    on: {
                      change: _vm.handleFormNotificarChange,
                      distribucionSelect: _vm.handleDistribucionSelect,
                      calendarioSelect: _vm.handleCalendarioSelect,
                      tipoNotificacionSeleccionado: _vm.handledTipoNotificacion
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("Confirmation", {
        attrs: {
          show: _vm.dialogConfirmacionGuardar,
          titulo: _vm.$t("mensajes.crud.crear.titulo", { entidad: "Alerta" }),
          mensaje: _vm.mensajeConfirmacion,
          textoBtnSi: _vm.$t("mensajes.crud.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.crear.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.handleConfirmacionGuardar($event)
          }
        }
      }),
      _c("MensajeValidacion", {
        attrs: {
          showDialog: _vm.showValidacion,
          titulo: _vm.tituloValidacion,
          mensaje: _vm.mensajeValidacion,
          items: _vm.itemsNoValidos
        },
        on: {
          modalConfirmationEmit: function($event) {
            _vm.showValidacion = false
          }
        }
      }),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "380" },
          model: {
            value: _vm.showValidacionLineal,
            callback: function($$v) {
              _vm.showValidacionLineal = $$v
            },
            expression: "showValidacionLineal"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticStyle: {
                        "font-size": "17px",
                        "margin-left": "10px !important"
                      }
                    },
                    [_vm._v(_vm._s(_vm.tituloValidacion))]
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c("v-card-text", [
                _c("span", [_vm._v("Debe ingresar:")]),
                _c("br"),
                _c("br"),
                _c(
                  "ul",
                  _vm._l(_vm.camposZonaEmpty, function(ce) {
                    return _c("li", { key: ce }, [_vm._v(_vm._s(ce))])
                  }),
                  0
                )
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { small: "", color: "primary" },
                      on: {
                        click: function($event) {
                          _vm.showValidacionLineal = false
                        }
                      }
                    },
                    [_vm._v("Aceptar")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }